<template>
  <div>
    <div class="page-header-wrapper padding-rb">
      <PageHeader :title="`Common HCP List`">
        <el-form class="filter-wrapper" label-width="60px">
          <el-col :span="6">
            <el-form-item label="Type">
              <el-select v-model="typeId" placeholder="Please select type" :loading="typeLoading" class="month-select" @change="typeSelectChange">
              <el-option v-for="item in typeOptions" :key="item.typeid" :label="item.typedescription" :value="item.typeid">
              </el-option>
            </el-select>
            </el-form-item>
          </el-col>
        </el-form>
        <el-input style="width: 208px;" prefix-icon="el-icon-search" placeholder="Search" v-model="searchVal"
          v-debounce="onSearch" clearable @clear="onSearch" />
        <el-button type="primary" class="ml10" @click="exportSEList" :loading="disableExportSEUser">
          Export
        </el-button>
      </PageHeader>
    </div>
    <div class="table-wrapper">
      <el-table ref="table" :data="tableData" v-loading="tableLoading" element-loading-text="Loading..."
        @sort-change="onSortChange" @select="handleSelect" @select-all="handleSelectionAll">
        <template>
          <el-table-column type="selection" width="45" align="center" />
        </template>
        <el-table-column prop="No" width="80" label="No." sortable="custom" align="center" v-if="role !== 1" />
        <el-table-column prop="SEName" label="Name" min-width="110" sortable="custom" />
        <el-table-column prop="province" label="Province" min-width="110" sortable="custom" />
        <el-table-column prop="City" label="City" min-width="80" sortable="custom" />
        <el-table-column prop="hospital" label="Hospital / Institution" min-width="180" sortable="custom" />
        <el-table-column prop="Department" label="Department" min-width="140" sortable="custom" />
        <el-table-column prop="Phone" label="Phone" min-width="100" sortable="custom" />
        <el-table-column prop="Types" label="Type" min-width="100" sortable="custom" />
        <el-table-column prop="Tags" label="Tag" min-width="200">
          <template slot-scope="{ row }">
            <hcp-tag-cell :value="row.Tags" />
          </template>
        </el-table-column>
        <el-table-column prop="EngagementProfile" label="Engagement Profile" width="180" sortable="custom" show-overflow-tooltip/>
        <el-table-column prop="Match" width="160" label="iDoctor Match" sortable="custom">
          <template slot-scope="{ row }">
            <el-tag :type="tagTypeParserForiDoctor(row.iDoctorStatus)" effect="dark">
              {{ tagLabelParserForiDoctor(row.iDoctorStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="Certified" width="150" label="eMSL Certified" sortable="custom">
          <template slot-scope="{ row }">
            <el-tag :type="tagTypeParser(row.Active)" effect="dark">
              {{ tagLabelParser(row.Active) }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wrap">
        <div class="actions">
          <el-button v-role="[1, 2, 3, 13]" type="text" icon="iconfont icon-transfer" size="medium"
            @click="handleTransferSE()" :disabled="multipleSelection.length === 0">
            Mass Transfer
          </el-button>
        </div>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          :pager-count="pagerCount" :page-sizes="[10, 25, 50, 100]" :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total" />
      </div>
    </div>
    <EditSEDialog :visible.sync="editSEDialogVisible" :data.sync="rowData" @success="onSuccess" />
    <QRCodeDialog :visible.sync="qrcodeDialogVisible" :data.sync="rowData" :title="qrTitle" />
    <TransferSEDialog :visible.sync="transferSEDialogVisible" :data.sync="seIds" @success="onSuccess"
      :type="transferType" pageType="CommonHCPList"/>
    <ImportSEDialog :visible.sync="importSEDialogVieible" @success="onSuccess(true)" />
    <BatchAddDialog ref="batchAddDialog" @success="operateUpload" />
    <TableDialog ref="tableDialog" @success="onSuccess(true)" />
  </div>
</template>

<script>
import QRCodeDialog from "./qrcode-dialog";
import EditSEDialog from "./edit-se-dialog";
import TransferSEDialog from "./transfer-se-dialog";
import ImportSEDialog from "./import-se-dialog";
import BatchAddDialog from "./batch-add-dialog";
import downloadjs from "downloadjs";
import { RoleCode } from "@/utils/role-constant";
import TableDialog from "./table-dialog";
import HcpTagCell from "@/components/hcp-tag-cell.vue";

export default {
  name: "My-SE",
  components: {
    ImportSEDialog,
    QRCodeDialog,
    EditSEDialog,
    TransferSEDialog,
    BatchAddDialog,
    TableDialog,
    HcpTagCell,
  },
  data() {
    return {
      tableLoading: true,
      searchVal: "",
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      typeId:'',
      orderBy: "CreatedOn",
      orderType: "descending",
      qrcodeDialogVisible: false,
      importSEDialogVieible: false,
      editSEDialogVisible: false,
      rowData: null,
      qrcodeUrl: "",
      multipleSelection: [],
      seIds: null,
      transferSEDialogVisible: false,
      transferType: '',
      qrTitle: 'SE/CE',
      type: null,
      disableExportSEUser:false,
      typeLoading:false,
      typeOptions:[{
              typedescription:'All',
              typeid:''
            }]
    };
  },
  computed: {
    role() {
      return this.$store.state.role;
    },
    templateUrl() {
      if (this.role === RoleCode.Admin) {
        return "/template/SEUserImportTemplate.xlsx";
      } else {
        return "/template/SupSEUserImportTemplate.xlsx";
      }
    },
    pagerCount() {
      let clientWidth = document.body.clientWidth;
      return clientWidth <= 1024 ? 5 : 7;
    },
    pageTitle() {
      return this.isVMSL ? 'vCE List' : 'HCP List'
    },
    isVMSL() {
      return this.role === RoleCode.VMSL;
    },
    isMSL() {
      return this.role === RoleCode.ML;
    },
  },
  created() {
    this.getTableData();
    this.getType()
    this.bus.$on("refresh", ({ name }) => {
      console.log(name)
      if (name === "Common HCP List" ) {
        this.getTableData();
      }
    });
  },
  methods: {
    getType(){
      this.typeLoading = true;
      this.axios
        .get(`/sys/getHcpType`)
        .then(({ code, data, msg }) => {
          if (200 === code) {
            this.typeOptions=[{
              typedescription:'All',
              typeid:''
            },
            ...data]
            this.form.typeId = ''
          } else {
            this.$message({
              type: "error",
              message: msg,
            });
          }
          this.typeLoading = false;
        })
        .catch(() => {
          this.typeLoading = false;
        });
    },
    goToSRMenuPage(row) {
      const SEID = row.SEID || ''
      const mlId = row.MLID || ''
      this.$router.push({ name: 'sr-menu', params: { seId: SEID, mlId } })
    },
    goToResendTerm(row) {
      console.log(row)
      // this.axios
      //   .get(`/se/seList`, {
      //     params: params,
      //   })
      //   .then(({ code, data, msg }) => {
      //     if (200 === code) {
      //       this.tableData = data.data;
      //       this.total = data.total;
      //       this.toggleRowSelection();
      //     } else {
      //       this.$message({
      //         type: "error",
      //         message: msg,
      //       });
      //     }
      //     this.tableLoading = false;
      //   })
      //   .catch(() => {
      //     this.tableLoading = false;
      //   });
    },
    goToViewPage(row) {
      const SEID = row.SEID || ''
      const MLID = row.MLID || 'noML'
      this.$router.push(`/se/${SEID}/${MLID}`)
    },
    operateUpload(data) {
      this.$refs.tableDialog.open(data);
    },
    handleUpload(command) {
      switch (command) {
        case "1":
          this.importSEDialogVieible = true;
          break;
        case "3":
          this.$refs.batchAddDialog.open();
          break;
      }
    },
    handleCommand(command) {
      switch (command) {
        case "1":
          this.exportMSLList();
          break;
        case "2":
          this.exportSEList();
          break;
        case "3":
          this.downloadTemplate();
          break;
      }
    },
    downloadTemplate() {
      this.axios
        .get(this.templateUrl, {
          baseURL: "/",
          responseType: "blob",
        })
        .then((data) => {
          downloadjs(
            data,
            `HCP_Import_Template.xlsx`,
            "application/vnd.ms-excel"
          );
          this.$message.success(`Download import template  successful!`);
        });
    },
    exportMSLList() {
      const msg = this.$message({
        message: `User list is exporting...`,
        duration: 0,
      });
      this.axios
        .get(`/user/exportUserList`, {
          responseType: "blob",
        })
        .then(({ data }) => {
          downloadjs(data.file, data.fileName, "application/vnd.ms-excel");
          msg.type = "success";
          msg.message = `Export User list successful!`;
          setTimeout(() => {
            msg.close();
          }, 3000);
        })
        .catch(() => {
          msg.type = "error";
          msg.message = `Export User list failure!`;
          setTimeout(() => {
            msg.close();
          }, 3000);
        });
    },
    exportSEList() {
      this.disableExportSEUser = true;
      let params = {
        pageSize: this.pageSize,
        page: this.currentPage,
        orderBy: this.orderBy,
        orderType: this.orderType,
        key: this.searchVal,
        typeId: this.typeId
      };
      const msg = this.$message({
        message: "HCP List is exporting...",
        duration: 0,
      });
      this.axios
        .get("/hcp/export", {
          responseType: "blob",
          params: params,
        })
        .then(({ data }) => {
          downloadjs(data.file, data.fileName, "application/vnd.ms-excel");
          msg.type = "success";
          msg.message = "Export HCP List successful!";
          this.disableExportSEUser = false
          setTimeout(() => {
            msg.close();
          }, 3000);
        })
        .catch(() => {
          msg.type = "error";
          msg.message = "Export HCP List failure!";
          this.disableExportSEUser = false
          setTimeout(() => {
            msg.close();
          }, 3000);
        });
    },
    tagTypeParser(flag) {
      let type = ''
      switch (flag) {
        case 0:
          type = 'danger'
          break;
        case 1:
          type = 'success'
          break;
        case 2:
          type = 'warning'
          break;
        default:
          type = 'danger'
          break;
      }
      return type
    },
    tagTypeParserForiDoctor(flag) {
      let type = ''
      switch (flag) {
        case 2:
          type = 'success'
          break;
        default:
          type = 'danger'
          break;
      }
      return type
    },
    tagLabelParserForiDoctor(flag) {
      let label = ''
      switch (flag) {
        case 2:
          label = 'Match'
          break;

        default:
          label = 'Mismatch'
          break;
      }
      return label
    },
    tagLabelParser(flag) {
      let label = ''
      switch (flag) {
        case 0:
          label = 'Uncertified'
          break;
        case 1:
          label = 'Certified'
          break;
        case 2:
          label = 'Pending certification'
          break;

        default:
          label = 'Uncertified'
          break;
      }
      return label
    },
    onSearch() {
      this.currentPage = 1;
      this.getTableData();
    },
    typeSelectChange() {
      this.currentPage = 1;
      this.getTableData();
    },
    getTableData() {
      this.tableLoading = true;
      let params = {
        pageSize: this.pageSize,
        page: this.currentPage,
        orderBy: this.orderBy,
        orderType: this.orderType,
        key: this.searchVal,
        typeId: this.typeId
      };
      this.axios
        .get(`/hcp/commonHcp`, {
          params: params,
        })
        .then(({ code, data, msg }) => {
          if (200 === code) {
            this.tableData = data.data;
            this.total = data.total;
            this.toggleRowSelection();
          } else {
            this.$message({
              type: "error",
              message: msg,
            });
          }
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getTableData();
    },
    handleSelect(selection, row) {
      let index = this.multipleSelection.findIndex((SEID) => SEID === row.SEID);
      if (index === -1) {
        this.multipleSelection.push(row.SEID);
      } else {
        this.multipleSelection.splice(index, 1);
      }
    },
    handleSelectionAll(select) {
      if (select.length > 0) {
        let seIds = Array.from(select, (i) => i.SEID);
        let result = seIds.filter((x) => {
          return !this.multipleSelection.some((y) => y === x);
        });
        this.multipleSelection = this.multipleSelection.concat(result);
      } else {
        let seIds = Array.from(this.tableData, (i) => i.SEID);
        seIds = seIds.filter((x) => {
          return this.multipleSelection.some((y) => y === x);
        });
        let result = this.multipleSelection.filter((x) => {
          return !seIds.some((y) => y === x);
        });
        this.multipleSelection = result;
      }
    },
    toggleRowSelection() {
      let rows = this.tableData.filter((i) => {
        return this.multipleSelection.some((SEID) => SEID === i.SEID);
      });
      rows.forEach((row) => {
        this.$nextTick(() => {
          this.$refs.table.toggleRowSelection(row, true);
        });
      });
    },
    onSuccess(resetPage = false) {
      this.orderBy = resetPage ? "CreatedOn" : this.orderBy;
      this.currentPage = resetPage ? 1 : this.currentPage;
      this.multipleSelection = [];
      this.getTableData();
    },
    onSortChange(column) {
      this.orderBy = column.prop;
      this.orderType = column.order;
      this.getTableData();
    },
    handleEdit(row) {
      this.rowData = row;
      this.editSEDialogVisible = true;
    },
    getQRCode(row) {
      this.rowData = row;
      this.qrTitle = row.Types.indexOf('vCE') > -1 ? 'vCE' : 'SE/CE'
      this.qrcodeDialogVisible = true;
    },
    handleDelete(seId) {
      if (!seId) {
        return;
      }
      this.$confirm("Once deleted, it cannot be recovered.", "Attention", {
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
      })
        .then(() => {
          let seIds = [seId];
          this.axios
            .post("/se/freeze", {
              seId: seIds,
            })
            .then(({ code, msg }) => {
              if (code === 200) {
                this.getTableData();
                this.$message.success("Delete HCP successfully");
              } else {
                this.$message.error(msg);
              }
            });
        })
        .catch(() => { });
    },
    handleMultiDelete() {
      if (this.multipleSelection.length === 0) {
        return;
      }
      this.$confirm(
        "Please make sure if it is ready to delete selected HCP(s)?",
        "Attention",
        {
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
        }
      )
        .then(() => {
          let seIds = this.multipleSelection;
          this.axios
            .post("/se/freeze", {
              seId: seIds,
            })
            .then(({ code, msg }) => {
              if (code === 200) {
                this.getTableData();
                this.multipleSelection = [];
                this.$message.success("Delete HCP(s) successfully");
              } else {
                this.$message.error(msg);
              }
            });
        })
        .catch(() => { });
    },
    handleTransferSE() {
      const selectedItems = this.tableData.filter(item => this.multipleSelection.includes(item.SEID));
      if (selectedItems.length === 0) return;
      this.seIds = selectedItems.map(item => item.SEID);
      const types = selectedItems[0]?.Types || '';
      const validTypes = ['SE', 'vCE', 'CE'];
      const parts = types.split(',').map(part => part.trim()).filter(part => part !== '');
      let transferType = '';
      for (const part of parts) {
        if (validTypes.includes(part)) {
          transferType = part;
          break;
        }
      }
      this.transferType = transferType;
      this.transferSEDialogVisible = true;
    }
  },
};
</script>
<style lang="scss" scoped>
.pagination-wrap {
  display: flex;
  justify-content: space-between;

  .actions {
    display: flex;
  }

  .transfer-actions,
  .el-button {
    margin-left: 10px;
  }
}

.ml10 {
  margin-left: 10px;
}

.select-wrapper {
  display: flex;

  .title {}
}

.el-select.month-select {
  width: 208px;
  margin-right: 10px;
  height: 28px;
}
::v-deep {
    .el-select.month-select > .el-input{
        height: 28px!important;
      }
   }
</style>
